module.exports = __webpack_public_path__ + "static/media/ic_coronavirus_insurance_fisdom.73cc92fe.svg";